var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{directives:[{name:"touch",rawName:"v-touch",value:({
    left: function (e) { return _vm.swipe({dir: 'left', ev: e}); },
    right: function (e) { return _vm.swipe({dir: 'right', ev: e}); }
  }),expression:"{\n    left: (e) => swipe({dir: 'left', ev: e}),\n    right: (e) => swipe({dir: 'right', ev: e})\n  }"}],class:[_vm.sidebarIsOpened, _vm.$router.currentRoute.name === 'group' && 'group-page-members-list-page']},[_c('router-view'),_vm._v(" "),_c('Footer',{key:_vm.renderingFooterPadding,attrs:{"paddingLeft":_vm.paddingLeft}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a1810c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 